
const setUsuario = (context,usuario) => {

	var 
		menu = (usuario && usuario.menu ? usuario.menu : []),
		acesso_permissao = (usuario && usuario.acesso_permissao ? usuario.acesso_permissao : []),
		acesso_modulo = (usuario && usuario.acesso_modulo ? usuario.acesso_modulo : []);
	
	context.commit('SET_USUARIO', usuario);
	context.commit('SET_MENU', menu);
	context.commit('SET_ACESSO_PERMISSAO', acesso_permissao);
	context.commit('SET_ACESSO_MODULO', acesso_modulo);
}

const setMenu = (context,menu) => {
	context.commit('SET_MENU', menu);
}

const setJwt = (context, jwt) => {
	context.commit('SET_JWT', jwt);
}

export{
	setUsuario,
	setMenu,
	setJwt
}





// WEBPACK FOOTER //
// ./src/store/usuario/actions.js